import AppRequests from "components/ProjectSpecificComponents/API/AppRequests/AppRequests"
import ROUTES from "components/ProjectSpecificComponents/Constants/ROUTES"
import { useFormStore } from "components/ProjectSpecificComponents/Contexts/FormStoreContext"
import { useStore } from "components/ProjectSpecificComponents/Contexts/GlobalStoreContext"
import { usePTKMStore } from "components/ProjectSpecificComponents/Contexts/PTKMStoreContext"
import { lostOrFinishedAdminSession } from "components/ProjectSpecificComponents/API/Functions/lostOrFinishedAdminSession"
import { observer } from "mobx-react"
import React from "react"
import { useHistory, useLocation } from "react-router-dom"
import styled from "styled-components"
import IconButton from "./IconButton"

interface Props {}

const MobileSaveButton = observer(({}: Props) => {
	const formStore = useFormStore()
	const ptkmStore = usePTKMStore()
	const store = useStore()
	const location = useLocation()
	const history = useHistory()

	const formSection = location.pathname.includes(ROUTES.FORM_CONFIGURATION)
	const ptkmSection = location.pathname.includes(ROUTES.PTKM_CONFIGURATION)

	const _onClick = (e: React.MouseEvent<HTMLDivElement>) => {
		formSection && saveSettingsData()
		ptkmSection && savePTKMData()
	}

	const saveSettingsData = async () => {
		let errMsg: string | undefined = formStore.checkIfConfigSpecificValuesExists()

		if (errMsg) {
			store.setInfoModalConfig({
				type: "fail",
				titleKey: "",
				descriptionKey: errMsg,
			})
			return
		}
		let config = formStore.selectedFormsConfigId
		const { ok, statusCode } = await AppRequests("Setting").put("updateFormsConfig", config, {
			formsConfigId: config?.id,
		})

		if (ok) {
			store.setInfoModalConfig({
				type: "info",
				titleKey: "data-saving.success",
				showDuration: 1000,
			})
			//Updates config state before edit
			formStore.setSelectedConfigFormBeforeEdit()
		} else if (statusCode == 401) {
			lostOrFinishedAdminSession(history, store)
		} else {
			store.setInfoModalConfig({
				type: "fail",
				titleKey: "data-saving.failed",
			})
		}
	}

	const savePTKMData = async () => {
		const { ok, statusCode } = await AppRequests("PTKM").put(
			"updatePTKMConfig",
			ptkmStore.ptkmConfig,
			{
				requestedItemId: ptkmStore.ptkmConfig.id,
			}
		)

		if (ok) {
			store.setInfoModalConfig({
				type: "info",
				titleKey: "data-saving.success",
				showDuration: 1000,
			})
			//Updates config state before edit
			ptkmStore.updateConfigBeforeUpdate()
		} else if (statusCode == 401) {
			lostOrFinishedAdminSession(history, store)
		} else {
			store.setInfoModalConfig({
				type: "fail",
				titleKey: "data-saving.failed",
			})
		}
	}

	return (
		<Base
			className="center-x-y"
			style={{
				backgroundColor: formStore.settingsData.personalize.colorButton,
			}}
			onClick={_onClick}
		>
			<IconButton
				iconKey="save"
				iconColor={formStore.settingsData.personalize.colorButtonText ?? "var(--white)"}
			/>
		</Base>
	)
})

export default MobileSaveButton

const Base = styled.div`
	width: 51px;
	height: 51px;
	border-radius: 50%;
	overflow: hidden;

	box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
`
